import { cn } from '@/lib/utils';

import type { PolymorphicComponentProps } from './types';

type RowProps<E extends React.ElementType = 'div'> =
    PolymorphicComponentProps<E> & {
        stackOnMobile?: boolean;
    };

/**
 * Row - Horizontal flex container
 * Maps to Figma's auto layout with horizontal direction
 *
 * @example
 * <Row className="gap-4 items-center">
 *   {children}
 * </Row>
 */
export const Row = <E extends React.ElementType = 'div'>({
    as,
    className,
    children,
    stackOnMobile = false,
    ...props
}: RowProps<E>) => {
    const Component = as || 'div';
    return (
        <Component
            className={cn(
                'flex flex-row',
                stackOnMobile && 'desktop:flex-row flex-col',
                className,
            )}
            {...props}
        >
            {children}
        </Component>
    );
};
